import { render, staticRenderFns } from "./LandParcelContracts.vue?vue&type=template&id=95fb7038&"
import script from "./LandParcelContracts.vue?vue&type=script&lang=js&"
export * from "./LandParcelContracts.vue?vue&type=script&lang=js&"
import style0 from "./LandParcelContracts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports